import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Filter16 } from '@carbon/icons-react';
import { Button } from 'carbon-components-react';
import Panel from './panel';
import { setEmailFilter } from 'redux/emails';
import { AssetOwnerEmailSearchFormInitialValues } from 'types';
import { useComponentMount } from 'utilities/hooks.util';
import Utils from 'utilities/helper.util';
import { isBrowser } from 'react-device-detect';

const defaultDay = Utils.getDateBeforeDays(0).startOf('day');

const initialValues: AssetOwnerEmailSearchFormInitialValues = {
  dateRange: 'today',
  createdAfter: defaultDay.utc().format(),
  createdBefore: '',
  externalId: '',
  status: []
};

const SearchFilter: React.FC<Props> = (props) => {
  const { isRefferal, mainContainerRef, onApply } = props;
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState<Boolean>(true);
  const [filterJson, setfilterJson] = useState<string>('');
  const [
    filterValues,
    setFilterValues
  ] = useState<AssetOwnerEmailSearchFormInitialValues>(initialValues);
  const [parentOverflow, setParentOverflow] = useState(true);

  const resetFilterValues = () => {
    setfilterJson(JSON.stringify(initialValues));
    setFilterValues(initialValues);
    setIsOpen(!isOpen);
  };

  const applyFilter = (values: AssetOwnerEmailSearchFormInitialValues) => {
    setfilterJson(JSON.stringify(values));
    setFilterValues(values);
    setIsOpen(!isOpen);
    onApply();
  };

  const onClickOpenButton = () => {
    setIsOpen(!isOpen);
  };

  const checkParentOverflow = useCallback(() => {
    const mainContainerElement = mainContainerRef.current;
    if (mainContainerElement) {
      if (
        mainContainerElement.scrollHeight > mainContainerElement.clientHeight &&
        isBrowser
      ) {
        setParentOverflow(true);
      }
    }
  }, [mainContainerRef, setParentOverflow]);

  useEffect(() => {
    filterJson && dispatch(setEmailFilter(JSON.parse(filterJson)));
  }, [filterJson, dispatch]);

  useEffect(() => {
    setIsOpen(true);
  }, [isRefferal, setIsOpen]);

  useEffect(() => {
    if (isOpen) {
      checkParentOverflow();
    } else {
      setParentOverflow(false);
    }
  }, [isOpen, checkParentOverflow, setParentOverflow]);

  useComponentMount(() => {
    setfilterJson(JSON.stringify(initialValues));
    setFilterValues(initialValues);
    return () => {
      dispatch(setEmailFilter(undefined));
    };
  });

  return (
    <div className="ao-emails-history--search-filter-container">
      <Button
        hasIconOnly
        renderIcon={Filter16}
        tooltipAlignment="center"
        tooltipPosition="bottom"
        iconDescription="Filter"
        kind="ghost"
        size="field"
        className={'ao-emails-history--search-filter-button'}
        onClick={onClickOpenButton}
      />
      {isOpen && (
        <Panel
          isRefferal={isRefferal}
          handleFilter={applyFilter}
          filterValues={filterValues}
          resetValues={resetFilterValues}
          handleOpenCloseFilter={(open: boolean) => setIsOpen(open)}
          parentOverflow={parentOverflow}
        />
      )}
    </div>
  );
};

type Props = {
  isRefferal: boolean;
  mainContainerRef: any;
  onApply: Function;
};

export default React.memo(SearchFilter);
